import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=e8acbfe2&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"
import style0 from "./orders.vue?vue&type=style&index=0&id=e8acbfe2&prod&scoped=true&lang=css"
import style1 from "./orders.vue?vue&type=style&index=1&id=e8acbfe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8acbfe2",
  null
  
)

export default component.exports